import { useLayoutEffect } from "react";
import { AcceleratorDocMetadata } from "../../models/AcceleratorDocMetadata";
import { StaleMessages } from "../../models/messages/Messages";
import "../../styles/stale/staleAlert.css";
import { Button } from "../buttons/Button";

export { StaleAcceleratorBatch };

type Props = {
  metadata?: AcceleratorDocMetadata;
  onConfirm: (stale: boolean) => void;
};
/**
 * Show nothing if AcceleratorDocMetadata undefined or not stale.
 *
 * @param props
 */
const StaleAcceleratorBatch = (props: Props) => {
  if (!props.metadata || !props.metadata.stale) {
    return null;
  }

  /* Always scroll so this component is visible */
  useLayoutEffect(() => {
    document
      .getElementsByClassName("staleAlert batch")[0]
      ?.scrollIntoView(true);
  });

  return (
    <div className={"staleAlert batch"}>
      <h3>Batch Instance {props.metadata.batchInstanceId} Is Stale</h3>
      <div>
        <span>{StaleMessages.staleBatch()}</span>
        {props.metadata.hasModelChanged && (
          <span>{StaleMessages.staleBatchSaveTemplateChanges()}</span>
        )}

        <div className={"fluffer"} />

        <div className={"buttons"}>
          {props.metadata.hasModelChanged && (
            <Button
              data-save-changes
              onClick={() => {
                props.onConfirm(true);
              }}
            >
              Save Changes
            </Button>
          )}
          <Button
            data-discard-changes
            onClick={() => {
              props.onConfirm(false);
            }}
          >
            Reload Batches
          </Button>
        </div>
      </div>
    </div>
  );
};
